// extracted by mini-css-extract-plugin
module.exports = {"playIcon":"Details_playIcon__j2x5Q","scrollOuter":"Details_scrollOuter__xf7TV","scrollInner":"Details_scrollInner__Kbd32","title":"Details_title__MlLIn"};